<template>
  <div class="md-layout">
    <!-- <div class="md-size-100 md-layout-item unstarted-div">
      <h3>Next Actions</h3>
      <div class="md-divider"></div>
      <h4>No current next actions</h4>
    </div> -->
    <div class="md-size-100 md-layout-item unstarted-div">
      <div class="flexed">
        <h3>All Projects</h3>
        <div class="md-autocomplete-search">
          <md-autocomplete
            class="search"
            v-model="selectedProject"
            :md-options="projectNames"
            :md-open-on-focus="false"
          >
            <label>Search by project name, ats or barcode...</label>
          </md-autocomplete>
        </div>

        <div class="buttons-group projects-status">
          <div class="md-group filters">
            <md-button
              class="md-info md-sm"
              :class="{'faded': currentFilter !== 'active'}"
              @click="switchFilters('active')"
            >
              Active
            </md-button>
            <md-button
              class="md-info md-sm"
              :class="{'faded': currentFilter !== 'completed'}"
              @click="switchFilters('completed')"
            >
              Completed
            </md-button>
            <md-button
              class="md-info md-sm"
              :class="{'faded': currentFilter !== 'all'}"
              @click="switchFilters('all')"
            >
              All
            </md-button>
          </div>
          <div class="md-group views">
            <md-button
              class="md-info md-sm"
              :class="{'faded': cardView}"
              @click="switchViews('list')"
            >
              List
            </md-button>
            <md-button
              class="md-info md-sm"
              :class="{'faded': listView}"
              @click="switchViews('card')"
            >
              Card
            </md-button>
          </div>
        </div>
      </div>

      <div class="md-divider"></div>

      <h4 v-if="projects.length == 0">You have no projects</h4>
    </div>
    <div class="pagination-header md-layout-item" v-if="projects.length > 0">
      <div class="per_page">
        <md-field>
          <label for="pages">Per page</label>
          <md-select v-model="perPage" @change="fetchData(1)">
            <md-option v-for="(item, index) in perPageOptions" :key="index" :value="item">{{ item }}</md-option>
          </md-select>
           <!-- <select id="per-page" v-model="perPage" @change="fetchData(1)">
    <option v-for="option in perPageOptions" :key="option" :value="option">{{ option }}</option>
  </select> -->
        </md-field>
      </div>

      <div class="md-layout-item full-width pagination-block" v-if="projects.length > 0">
        <ul class="pagination">
          <li
            class="page-item prev-page"
            :class="{ disabled: value === 1, 'no-arrows': noArrows }"
          >
            <a class="page-link" aria-label="Previous" @click="previousPage">
              <i class="fas fa-angle-double-left"></i>
            </a>
          </li>
          <li
            class="page-item"
            v-for="pageNumber in displayedPages"
            :key="pageNumber"
            :class="{ active: pageNumber === currentPage }"
          >
            <a v-if="pageNumber" @click="goToPage(pageNumber)" :class="[ 'page-link', { active: pageNumber === currentPage } ]">{{ pageNumber }}</a>
            <span v-else>...</span>
          </li>
          <li
            class="page-item page-pre next-page"
            :class="{ disabled: value === totalPages, 'no-arrows': noArrows }"
          >
            <a class="page-link" aria-label="Next" @click="nextPage">
              <i class="fas fa-angle-double-right"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-small-size-100 md-size-33 product-project"
      v-for="project in viewedProjects"
      :key="project.name"
    >
        <md-card
          v-if="cardView"
          class="md-card-product"
        >
          <md-card-header>
            <div class="items" @click="goToProject(project.project.id)">
              <div class="title"><h4>{{ project.project.name }}</h4><small>{{ project.project.created_at | formatDate }}</small></div>
              <h5 class="subtitle">
                ATS# {{ project.ats }}
              </h5>
            </div>
          </md-card-header>
          <img class="img" :src="setStaticMap(project.address)" @click="goToProject(project.project.id)" />

          <md-card-content @click="goToProject(project.project.id)">
            <div class="card-description">
              <p>Requested By: {{project.company}}</p>
              <p>Created By: {{project.creator}}</p>
              <p>PO Number: {{project.po_no}} | Job Number: {{project.job_no}}</p>
              <p v-if="project.last_status && project.last_status.step == 10" class="complete">COMPLETED</p>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="space-between" >
            <div class="price"  @click="goToProject(project.project.id)">
                <h4>OPEN</h4>
            </div>
            <div class="price"  @click="redirectToGoogleMaps(project.address)">
                <h4>Directions</h4>
            </div>
          </md-card-actions>
        </md-card>

      <md-card class="list-view-item" v-if="listView" >
        <md-card-header>
          <div @click="goToProject(project.project.id)">
            <h4>{{project.project.name}}</h4>
            <p>Created At: {{ project.project.created_at | formatDate }}</p>
          </div>
        </md-card-header>
        <md-card-content>
          <div @click="goToProject(project.project.id)">
            <h5>ATS# {{project.ats}}</h5>
            <h5>Requested By: {{project.company}}</h5>
            <h5>Created By: {{project.creator}}</h5>
            <p>PO Number: {{project.po_no}} | Job Number: {{project.job_no}}</p>
          </div>
        </md-card-content>
      </md-card>

    </div>
    <div class="md-layout-item full-width pagination-block">
      <ul class="pagination">
        <li
          class="page-item prev-page"
          :class="{ disabled: value === 1, 'no-arrows': noArrows }"
        >
          <a class="page-link" aria-label="Previous" @click="previousPage">
            <i class="fas fa-angle-double-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          v-for="pageNumber in displayedPages"
          :key="pageNumber"
          :class="{ active: pageNumber === currentPage }"
        >
          <a v-if="pageNumber" @click="goToPage(pageNumber)" :class="[ 'page-link', { active: pageNumber === currentPage } ]">{{ pageNumber }}</a>
          <span v-else>...</span>
        </li>
        <li
          class="page-item page-pre next-page"
          :class="{ disabled: value === totalPages, 'no-arrows': noArrows }"
        >
          <a class="page-link" aria-label="Next" @click="nextPage">
            <i class="fas fa-angle-double-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { ProductCard } from "@/components";

import api from "@/api";
import store from "@/store";
import moment from 'moment';
import axios from 'axios';

export default {
  components: {
    // ProductCard
  },
  data() {
    return {
      product1: "./img/map.png",
      user: "",
      projects: {},
      listView: false,
      cardView: true,
      viewedProjects: {},
      currentFilter: 'all',
      selectedProject: '',
      projectNames: [],
      currentPage: 1,
      totalPages: 1,
      perPageOptions: [10, 25, 50, 100],
      perPage: 25,
      noArrows: false,
      value: {
      type: Number,
      default: 1
    }
    };
  },
  async created() {
    // api.getProjects().then((response) => {
    //   this.projects = response.data.projects.reverse();
    //   this.viewedProjects = this.projects.filter((p) => p.last_status.step !== 10);
    //   this.projectNames = this.projects.map((proj) => {
    //     return proj.project.name
    //   })
    // });
    await this.fetchData(this.currentPage);
  },
  watch: {
    selectedProject: function(){
      this.fetchData(this.currentPage);
      // if (this.selectedProject == ''){
      //   this.switchFilters(this.currentFilter);
      // } else {
      //   var lower = this.selectedProject.toLowerCase();
      //   this.viewedProjects = this.viewedProjects.filter((p) => {
      //     var name = p.project.name.toLowerCase();
      //     var job_no = p.job_no ? p.job_no.toString() : '';
      //     if (name.includes(lower) || job_no.includes(lower)){
      //       return p
      //     }

      //   });
      // }

    },
    perPage: function(event) {
      this.fetchData(1)
    }
  },
  methods: {
    goToProject(id){
      this.$router.push(`/projects/${id}`)
    },
    switchViews(style){
      if (style == "card") {
        this.listView = false;
        this.cardView = true;
      } else if (style == "list") {
        this.listView = true;
        this.cardView = false;
      }
    },
    switchFilters(style){
      if (style == "all") {
        this.currentFilter = 'all'
        this.viewedProjects = this.projects;
        this.selectedProject = ''
      } else if (style == "completed") {
        this.currentFilter = 'completed'
        var filteredProjects = this.projects.filter((p) => p.last_status.step == 10)
        this.viewedProjects = filteredProjects
        this.selectedProject = ''
      } else if (style == "active") {
        this.currentFilter = 'active'
        var filteredProjects = this.projects.filter((p) => p.last_status.step !== 10)
        this.viewedProjects = filteredProjects
        this.selectedProject = ''
      }
    },
    setStaticMap(address){
      if (address) {
        var mapHeight = 150;
        if (window.screen.width > 550 && window.screen.width < 1000) {
          mapHeight = 100;
        }
        var url = "https://maps.googleapis.com/maps/api/staticmap?center="+ address + "&zoom=14&size=400x"+ mapHeight + "&markers=color:blue|" + address + "&key=AIzaSyDWR-_uD0kmb6GUTgq08R5zpwrQV7VHzkE"
        return url
      }
    },
     redirectToGoogleMaps(address) {
      var url = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(address);
      window.open(url, '_blank');
    },
    async fetchData(page) {
      try {
        const response = await axios.get('/projects', {
          params: {
            page: page,
            per_page: this.perPage,
            search: this.selectedProject.toLowerCase()
          },
        });
        // this.items = response.data.items;
        this.totalPages = response.data.totalPages;

        this.projects = response.data.projects;
        this.viewedProjects = this.projects;
        this.currentPage = page;
        this.currentFilter = 'all';
        this.projectNames = this.projects.map((proj) => {
          return proj.project.name
        })


      } catch (error) {
        console.error(error);
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchData(this.currentPage);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchData(this.currentPage);
      }
    },
    goToPage(pageNumber) {
      this.fetchData(pageNumber);
    },

  },
  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },
  computed: {
    displayedPages() {
      const delta = 2;
      const range = [];
      const totalPages = this.totalPages;
      let left = this.currentPage - delta;
      let right = this.currentPage + delta;
      let i;

      for (i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= left && i <= right)) {
          range.push(i);
        } else if (range[range.length - 1] !== null) {
          range.push(null);
        }
      }

      return range;
    },
  },
};
</script>

<style lang="scss">
.md-layout {
  width: 80%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}
.unstarted-div {
  border-bottom: 2px solid #2274a5;
  h3 {
    font-weight: 500;
    color: #033860;
  }
}
.product-project {
  cursor: pointer;
}
.pagination-block  span{
  margin: 0px 5px;
}
.pagination-block {
  flex-basis: 100%;
  text-align: center;
}
.pagination-block .pagination{
  justify-content: end;
}
.pagination-header{
    flex-basis: 100%;
    text-align: center;
    display: flex;
    margin-top: 20px;
}
</style>
